import { core, dateUtil } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    table() {
      return $(`
      <table class="year-table" style="display:none;">
        <tbody>
          <tr>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td class="available">
              <a class="cell"></a>
            </td>
          </tr>
          <tr>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td class="available">
              <a class="cell"></a>
            </td>
          </tr>
          <tr>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td class="available">
              <a class="cell"></a>
            </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>`)
    }
  },
  updater: {
    // 基本属性: date
    date(value, opt, tar, node) {
      const cells = tar.unit.find('.cell')
      const start = tar.startYear()
      Array.from(cells).map((item, i) => {
        const year = start + i
        $(item).text(start + i)
        const td = $(item).closest('td')
        // 增加已选中的标识
        const [y] = dateUtil.getDateArr(value)
        if (year === y) td.addClass('current')
        else td.removeClass('current')
        // 增加今日标识
        const [yy] = dateUtil.getDateArr(new Date())
        if (year === yy) td.addClass('today')
        else td.removeClass('today')
      })
    },
    // 基本功能: 是否显示
    show(value, opt, tar, node) {
      if (value) {
        tar.unit.show()
      } else {
        tar.unit.hide()
      }
      tar.shown()
    }
  }
}

export default class YearTable extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      show: false, // 基本功能: 显示/隐藏
      date: new Date(), // 基本属性: 设置时间
      max: null, // 基本属性: 最大时间
      min: null // 基本属性: 最小时间
    }
    this.events = {
      click: 'onClick',
      shown: null
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init () {
    const opt = this.settings
    const template = util.template.table(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    this.unit.click($.proxy(this.click, this))
  }

  startYear() {
    return Math.floor((this.date.getFullYear() + 6) / 10) * 10 + (new Date().getFullYear() % 10) - 4
  }

  onClick(event) {
    const target = event.target
    if (target.tagName === 'A') {
      if ($(target).parent().hasClass('disabled')) {
        return false
      }
      return target.textContent || target.innerText
    }
    return false
  }
}
